import React, { useRef } from "react";
import * as styles from "./SummaryPod.module.css";
import { Cta } from "../Cta/Cta";
import { CustomRichTextElement } from "../CustomRichTextElement/CustomRichTextElement";
import { Image, KontentRichText } from "../../../types";
import { Link } from "../Link/Link";
import { KontentImageElement } from "../KontentImageElement/KontentImageElement";
import AnimationWrapper from "../../containers/AnimationWrapper";

export interface SummaryPodProps {
  subhead: string;
  text?: KontentRichText;
  image?: Image;
  ctaLabel?: string;
  ctaHref?: string;
  ctaTarget?: string;
  ctaAction?: "_blank" | "_self";
  hideTextOnMobile?: boolean;
  clickableTile?: boolean;
  displayImages?: boolean;
  className?: string;
  squareImage?: boolean;
  animate?: boolean;
  summaryAlignment?: "by_title" | "by_link";
}

export const SummaryPod: React.FC<SummaryPodProps> = ({
  subhead,
  text,
  ctaLabel,
  ctaHref,
  ctaTarget,
  image,
  hideTextOnMobile,
  clickableTile,
  className,
  displayImages = true,
  squareImage = true,
  animate = false,
  summaryAlignment,
}) => {
  const contentClasses = [styles.content];
  summaryAlignment === "by_title" && contentClasses.push(styles.alignStart);

  const tileWrapper = useRef(null);

  const renderImage = () => (
    <KontentImageElement
      aspectRatio={squareImage ? 1 : undefined}
      objectFit="cover"
      layout="fullWidth"
      image={image?.item}
      alt={image?.alt}
    />
  );

  const renderTile = () => {
    return (
      <div className={`${styles.summaryPod} ${className}`} ref={tileWrapper}>
        <div className={contentClasses.join(" ")}>
          {displayImages &&
            image &&
            image.item &&
            (animate ? (
              <AnimationWrapper
                behavior="fadeInUp"
                className={styles.imageContainer}
              >
                {renderImage()}
              </AnimationWrapper>
            ) : (
              <div className={styles.imageContainer}>{renderImage()}</div>
            ))}
          <div className={styles.textContainer}>
            <h2>{subhead}</h2>
            {text && (
              <div
                className={
                  styles.text + (hideTextOnMobile ? " hide-mobile" : "")
                }
              >
                <CustomRichTextElement content={text} />
              </div>
            )}
          </div>
          {ctaLabel && ctaHref && !clickableTile && (
            <div className={styles.ctaContainer}>
              <Cta href={ctaHref} target={ctaTarget} label={ctaLabel} />
            </div>
          )}
        </div>
      </div>
    );
  };

  return ctaHref && clickableTile ? (
    <div className={styles.clickableTile}>
      <Link to={ctaHref} target={"_self"}>
        {renderTile()}
      </Link>
    </div>
  ) : (
    renderTile()
  );
};
